import {IdName} from '@domain/id-name';
import {DateTime} from 'luxon';

export class NonWorkingDay extends IdName {
  private _start: DateTime;
  private _end: DateTime;

  public constructor(id: number, name: string, start: DateTime, end: DateTime) {
    super(id, name);
    this._start = start;
    this._end = end;
  }

  public get start(): DateTime {
    return this._start;
  }

  public set start(value: DateTime) {
    this._start = value;
  }

  public get end(): DateTime {
    return this._end;
  }

  public set end(value: DateTime) {
    this._end = value;
  }

  public static fromJSON(scheduleCustomSettingsJSON: any): NonWorkingDay {
    return new NonWorkingDay(
      scheduleCustomSettingsJSON.id,
      scheduleCustomSettingsJSON.name,
      DateTime.fromISO(scheduleCustomSettingsJSON.start, {zone: 'utc'}).setZone(DateTime.local().zoneName, {keepLocalTime: true}),
      DateTime.fromISO(scheduleCustomSettingsJSON.end, {zone: 'utc'}).setZone(DateTime.local().zoneName, {keepLocalTime: true})
    );
  }

  public toJSON(): JSON {
    return {
      id: this._id,
      name: this._name,
      start: this._start.toUTC(0, {keepLocalTime: true}).toISO(),
      end: this._end.toUTC(0, {keepLocalTime: true}).toISO()
    } as any as JSON;
  }
}
